import { apiUrl } from './api';

// ─────────────────────────────────────────────────────────────────
// Annonslänkar (Admin → Marknadsföring) ser ut så här:
//   https://qvestium.com/?tab=plagg&ref=QM…&utm_source=meta&utm_campaign=launch_test&utm_content=friends_a
// ref är kampanjens inbjudningskod — den fylls i automatiskt vid registrering,
// så att annonstrafiken kommer in utan att känna till någon kod. UTM-värdena
// skickas med registreringen och avgör vilken variant kontot räknas till.
// Allt sparas bara i fliken (sessionStorage), som inbjudningskoden från CRM:et.
// Körs i main.tsx innan appen läser ?tab=… och städar adressen.
// ─────────────────────────────────────────────────────────────────

export const INVITE_KEY = 'qv_invite';
const ATTRIBUTION_KEY = 'qv_attribution';
const PARAMS = ['ref', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'ttclid'];

export interface Attribution { source?: string; medium?: string; campaign?: string; content?: string; clickId?: string; landing?: string }

export function captureCampaignParams(): void {
  const params = new URLSearchParams(window.location.search);
  const ref = params.get('ref')?.trim();
  const campaign = params.get('utm_campaign')?.trim();
  if (!ref && !campaign) return;

  const attribution: Attribution = {
    source: params.get('utm_source') ?? undefined,
    medium: params.get('utm_medium') ?? undefined,
    campaign,
    content: params.get('utm_content') ?? undefined,
    clickId: params.get('fbclid') ?? params.get('ttclid') ?? undefined,
    landing: window.location.pathname + (params.get('tab') ? `?tab=${params.get('tab')}` : ''),
  };
  try {
    sessionStorage.setItem(ATTRIBUTION_KEY, JSON.stringify(attribution));
    // En personlig inbjudan (?invite=) går före kampanjkoden.
    if (ref && !sessionStorage.getItem(INVITE_KEY)) sessionStorage.setItem(INVITE_KEY, ref);
  } catch { /* privat läge */ }

  if (campaign) {
    fetch(apiUrl('/api/marketing/landing'), {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true,
      body: JSON.stringify({ campaign, content: attribution.content, source: attribution.source }),
    }).catch(() => { /* räknas inte — viktigare att sidan laddar */ });
  }

  for (const p of PARAMS) params.delete(p);
  window.history.replaceState(window.history.state, '', `${window.location.pathname}${params.toString() ? `?${params}` : ''}${window.location.hash}`);
}

export function storedAttribution(): Attribution | undefined {
  try {
    const raw = sessionStorage.getItem(ATTRIBUTION_KEY);
    return raw ? JSON.parse(raw) as Attribution : undefined;
  } catch { return undefined; }
}
